import { FC } from "react";
import { observer } from "mobx-react-lite";
import StatusHistory from "../data/statusHistory/statusHistory";
import { ExpandedTable, Popup, StoredPagination } from "../../../ui-kit";

import defectPopupStore from "../../../store/defectPopup";

interface IDefectTableProps {
  dataSource?: Array<any>;
  paginator: any;
  sorter?: any;
  isLoading: boolean;
  planned?: boolean;
  columns?: Array<any>;
  rowSelection?: any;
  openDefect?: (id: string) => void;
}

const DefectTable: FC<IDefectTableProps> = observer(
  ({
    dataSource,
    paginator,
    sorter,
    isLoading,
    columns,
    rowSelection,
    openDefect,
  }) => {
    const { selectedDefect, openPopupDefect, togglePopupDefect } =
      defectPopupStore;
    return (
      <>
        <ExpandedTable
          columns={columns}
          sort={sorter}
          data={dataSource}
          rowSelection={rowSelection}
          rowKey={(record) => record.id}
          rowsLength={paginator.perPage}
          scroll={{ x: "max-content" }}
          loading={isLoading}
          onRow={(record) => {
            return {
              onClick: (evt) => {
                if (record?.id && openDefect && !evt.target?.href) {
                  openDefect(record.id);
                }
              },
            };
          }}
        />
        <StoredPagination {...paginator} />
        <Popup
          open={openPopupDefect.value}
          onClose={togglePopupDefect}
          title={`История изменений статуса дефекта № ${selectedDefect}`}
        >
          <StatusHistory defectId={selectedDefect} />
        </Popup>
      </>
    );
  },
);

export default DefectTable;
